module.exports = __webpack_public_path__ + "img/img4.7cf6a27f.svg";